export default __webpack_public_path__ + "static/media/logo.20f37f1e.png";